"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KnockNotificationButton = require("./KnockNotificationButton");
Object.keys(_KnockNotificationButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KnockNotificationButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _KnockNotificationButton[key];
    }
  });
});